import mod from "-!./APagination.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./APagination.js?vue&type=script&lang=js&external"